import { Component, ViewEncapsulation } from "@angular/core";
import { MdbModalRef } from "mdb-angular-ui-kit/modal";

@Component({
  selector: "app-devicenotrecommended-modal",
  templateUrl: "./devicenotrecommended-modal.component.html",
  styleUrls: ["./devicenotrecommended-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class devicenotrecommendedModalComponent {
  constructor(
    public modalRef: MdbModalRef<devicenotrecommendedModalComponent>,
  ) {}

  close() {
    this.modalRef.close();
  }
}
